<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WFDetector - WSFinder
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WFDetector</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">WSFinder</a>
          </li>
      </ul>
    </div>
    <!-- <router-view @refresh="refresh()"></router-view> -->
    <b-card>
      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" /> -->
          <span>オンラインエージェントを選択可能</span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="$refs._list.refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '検索'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='host';so.skt='Host';so.adv=false;so.sv=''">ホスト</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='Name';so.adv=false;so.sv=''">名前</b-dropdown-item>
                <!-- <b-dropdown-item size="sm" @click="so.sk='tag';so.skt='TAG';so.adv=false;so.sv=''">タグ</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='ip_addr';so.skt='IP';so.adv=false;so.sv=''">IP</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" v-show="!so.adv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          <p class="text-danger font-weight-bold">
            偽造ターゲットが多い場合、モニタリングに失敗することがあります。最小限の範囲で設定することをお勧めします。
          </p>
        </b-col>
      </b-row>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="ping" slot-scope="row" v-show="this.agents[row.index].ms">
          <b-badge variant="success" v-if="row.item.alive">オンライン{{ row.item.ms ? ` (${row.item.ms} ms)` : ''}}</b-badge>
          <b-badge v-else>オフライン</b-badge>
        </template>
        <template slot="name" slot-scope="row">{{ row.item.name || '-'}}</template>
        <template slot="host" slot-scope="row">{{ row.item.host }}</template>
        <template slot="tag" slot-scope="row">{{ row.item.tag }}</template>>
        <template slot="os_type" slot-scope="row">{{ row.item.os_type }}</template>
        <template slot="ip_addr" slot-scope="row">
          {{row.item.ip_addr_public}} / {{row.item.ip_addr_private}}
        </template>
        <template slot="setting" slot-scope="row">
          <b-badge variant="success" v-if="row.item.setting.forgery_mode || false">有効</b-badge>
          <b-badge v-else>無効</b-badge>
        </template>
        <template slot="select" slot-scope="row">
          <b-button :variant="(row.item.alive ? (model && model.id == row.item.id ? 'danger' : 'primary') : 'secondary')" size="sm" @click="select(row.item)" :disabled="!row.item.alive">
            {{(model && model.id == row.item.id ? 'Selected' : 'Select')}}
          </b-button>
        </template>
      </b-table>
      <template v-if="!this.show">
        <b-card>
          <tr>
            <th>設定可能なエージェントはありません</th>
          </tr>
        </b-card>
      </template>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="so.totalRows" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
    <b-card  class="text-center" v-if="model && !model.id">
      <span>エージェントを選択してください</span>
    </b-card>
    <b-card v-else>
      <b-row>
        <b-col md="6">
          <span class="float-left">インストール済み : {{model.created_at | datetime }}</span>
          <br>
          <span class="float-left">Name : {{model.name}} ({{model.host}}@{{model.ip_addr}})</span>
        </b-col>
        <b-col>
          <span class="float-left" @click="model.setting.forgery_mode = !model.setting.forgery_mode" v-b-tooltip.hover title="変更可 有効、設定完了、認証変更可" cusor="pointer" style="cursor:pointer">
            ステータス :
            <b-badge variant="success" v-if="model.setting.forgery_mode || false">有効</b-badge>
            <b-badge v-else>無効</b-badge>
          </span>
        </b-col>
        <b-col>
          <b-button class="float-right" variant="outline-primary" size="sm" @click="detail()">管理</b-button>
          <b-button class="float-right" variant="outline-warning" size="sm" @click="reset_usage(true)">クリア</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <center>
            <h5 class="text-danger">* 整合性が必要なフォルダーを設定する（例：設定フォルダーとバックアップフォルダー）</h5>
            <!-- <h5 class="text-danger">* データやファイルの変更を行わないようにするルート</h5> -->
          </center>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center" v-if="request">
      <span>
        <i :class="`fa fa-refresh fa-spin`"></i>
        loading....
      </span>
    </b-card>
    <folderSet
      v-if="!request && model && model.id"
      :press="press_save"
      :is_refresh="model.alive"
      :show="dir.length"
      :item="dir"
      :scan_list="watching"
      :scan_list_history="watching_history"
      :white_path="white_path"
      :white_file="white_file"
      :white_file_active="true"

      @path="get_path"
      @save="save"
      @remove="remove_select"
      @clear="clear"

      @add_white_list_file="add_white_list_file"
      @add_white_list="add_white_list"
      @add_scan_list="add_watching"

    />
    <br>
    </div>

</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
